module.exports = __webpack_public_path__ + "static/step-3-6b889e8273962b29f00d9a9596decc83.png";